import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
// ----------------------------------------------------------------------------------------------------------------

DebouncedInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    debounce: PropTypes.number,
    loading: PropTypes.bool,
    isExporting: PropTypes.bool,
};
// ----------------------------------------------------------------------------------------------------------------

export default function DebouncedInput({ value: initialValue, loading, isExporting, onChange, debounce = 500,
    ...props }) {

    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);

        return () => clearTimeout(timeout);
    }, [value, debounce, onChange]);

    const clearInput = () => {
        setValue(''); // Clear the input value
    };

    return (
        <TextField
            className="filtersColumns"
            disabled={loading || isExporting}
            variant="outlined"
            autoFocus
            size="small"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            InputProps={{
                style: { fontSize: '0.7rem', },
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={clearInput} aria-label="Clear search">
                            <ClearIcon className="clearIconStyle" fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            style={{ width: { xs: '100px', sm: '150px', md: '200px', lg: '250px' } }}
            fullWidth
            placeholder="Search..."
            autoComplete="off" // Disables autocomplete
        />);
}